import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { uniqueValueValidator } from 'src/app/shared/validators/validators';

@Component({
  selector: 'app-add-quick-filters-modal',
  templateUrl: './add-quick-filters-modal.component.html',
})
export class AddQuickFiltersModalComponent implements OnInit {
  formQuickFilter: UntypedFormGroup;
  quickFiltersNames?: string[];

  constructor(
    private fb: UntypedFormBuilder,
    private activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.formQuickFilter = this.fb.group({
      filterName: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(40),
          uniqueValueValidator(this.quickFiltersNames ?? []),
        ],
      ],
      setAsDefault: false,
    });
  }

  close() {
    this.activeModal.dismiss();
  }

  save() {
    const result: AddQuickFiltersModalResult = {
      filterName: this.formQuickFilter.value.filterName,
      setAsDefault: this.formQuickFilter.value.setAsDefault,
    };

    this.activeModal.close(result);
  }
}

export type AddQuickFiltersModalResult = {
  filterName: string;
  setAsDefault: boolean;
};
